









import Vue from 'vue';

type LegendItem = { icon: string; name: string };

export default Vue.extend({
  data() {
    return {
      items: [
        {
          icon: 'fa-digital-tachograph',
          name: 'Binnen',
        },
        {
          icon: 'fa-solar-panel',
          name: 'Buiten',
        },
        {
          icon: 'fa-ruler-horizontal',
          name: 'Plat dak',
        },
        {
          icon: 'fa-ruler',
          name: 'Schuin dak',
        },
      ] as LegendItem[],
    };
  },
});
